import { HighlightStyle, syntaxHighlighting } from '@codemirror/language'
import { EditorView } from '@codemirror/view'
import { tags } from '@lezer/highlight'

/** Palette-derived highlighting. Colours come from the CSS tokens so themes stay in one place. */
export const plotHighlight = HighlightStyle.define([
  { tag: tags.keyword, color: 'var(--c-dusk-bright)' },
  {
    tag: [tags.function(tags.variableName), tags.function(tags.propertyName)],
    color: 'var(--c-ice)',
  },
  { tag: [tags.variableName, tags.propertyName], color: 'var(--c-cream)' },
  { tag: tags.number, color: 'var(--c-lamp)' },
  { tag: tags.string, color: 'var(--c-moss)' },
  { tag: tags.comment, color: 'var(--c-stone)', fontStyle: 'italic' },
  { tag: [tags.operator, tags.punctuation], color: 'var(--c-ash)' },
  { tag: tags.bool, color: 'var(--c-blossom)' },
])

export const plotTheme = EditorView.theme(
  {
    '&': {
      backgroundColor: 'var(--c-surface)',
      color: 'var(--c-cream)',
      fontFamily: 'var(--font-mono)',
      fontSize: 'var(--text-code)',
      height: '100%',
    },
    '.cm-content': { caretColor: 'var(--c-lamp)', padding: '12px 0' },
    '.cm-cursor, .cm-dropCursor': { borderLeftColor: 'var(--c-lamp)', borderLeftWidth: '2px' },
    '&.cm-focused .cm-selectionBackground, .cm-selectionBackground, ::selection': {
      backgroundColor: 'var(--c-selection)',
    },
    '.cm-activeLine': { backgroundColor: 'var(--c-surface-raised)' },
    '.cm-activeLineGutter': { backgroundColor: 'var(--c-surface-raised)' },
    '.cm-gutters': {
      backgroundColor: 'var(--c-surface)',
      color: 'var(--c-stone)',
      border: 'none',
      borderRight: '2px solid var(--c-line)',
    },
    '.cm-lineNumbers .cm-gutterElement': { minWidth: '3ch', padding: '0 8px 0 4px' },
    '.cm-matchingBracket': { outline: '1px solid var(--c-lamp)', backgroundColor: 'transparent' },
    '.cm-lint-marker-error': { content: 'none' },
    '.cm-diagnostic-error': { borderLeft: '3px solid var(--c-brick)' },
    '.cm-tooltip': {
      backgroundColor: 'var(--c-surface-raised)',
      border: '2px solid var(--c-line)',
      color: 'var(--c-cream)',
      fontFamily: 'var(--font-mono)',
    },
    '&.cm-focused': { outline: 'none' },
  },
  { dark: true },
)

export const plotSyntax = syntaxHighlighting(plotHighlight)
